<template>
  <div>
    <h4>REALIZADOS</h4>
    <ProductionQueue :list="list"></ProductionQueue>
  </div>
</template>
<script>
import ProductionQueue from "./production-queue/ProductionQueue.vue";
import { DinnerService } from "./DinnerService";
import { getCurrentDate } from "src/lt-module/utils/myMoment.js";
export default {
  components: {
    ProductionQueue
  },

  // directives
  // filters

  props: {
    //
  },

  data: () => ({
    list: []
  }),

  computed: {
    //
  },

  watch: {
    //
  },

  mounted() {
    this.getList();
  },

  methods: {
    getList() {
      DinnerService.getKitchenWorks({
        maked: 1,
        date: getCurrentDate(),
        per_page: 10000
      }).then((res) => {
        this.list = res.data;
      });
    }
  }
};
</script>

<style scoped></style>
